import statementPasswordForm from "form/modal/statementPassword";

import { FORM_EDIT_STATEMENT_PASSWORD } from "../constants";

export const ModalStatementPasswordForm = statementPasswordForm.createContainer(FORM_EDIT_STATEMENT_PASSWORD);
